// extracted by mini-css-extract-plugin
export var bodyRow = "_e2-d";
export var cardColumns = "_e2-e";
export var ellipsesOverflow = "_e2-2";
export var flatBottomCorners = "_e2-3";
export var flatTopCorners = "_e2-4";
export var headerActionsDropdown = "_e2-f";
export var headerBottomRow = "_e2-c";
export var headerTopRow = "_e2-b";
export var orderDetailsWrapper = "_e2-0";
export var orderInfoContainer = "_e2-1";
export var productDetails = "_e2-9";
export var productImage = "_e2-5";
export var responsiveTable = "_e2-8";
export var shipmentContainer = "_e2-a";
export var tableBottomLeft = "_e2-6";
export var tableBottomRight = "_e2-7";
export var trackingLink = "_e2-g";